import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import PersonHeader from '../components/PersonHeader';
import Page from '../../components/shared/Page';
import HelpText from '../../components/help/HelpText';
import { renderErrorWarning, renderErrors } from '../../utilities/Forms.js'

class PersonPreferences extends Component {
  constructor(props) {
    super(props);

    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    organisation_name: "",
    person_name: "",
    email_opt_out: [],

    loaded: false,
    errors: ""
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = {
      "person": {
        "email_opt_out": this.state.email_opt_out
      }
    }

    request("PUT", `/v1/p/person_preferences/0?marketing_token=${this.props.match.params.marketing_token}`, JSON.stringify(json), () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Preferences updated successfully!`);

        this.setState({
          organisation_name: data.organisation_name,
          person_name: data.person_name,
          email_opt_out: data.email_opt_out,
          updating: false
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  handleMultiCheckbox(event) {
    const name = event.target.name;
    const value = !event.target.checked // Values are flipped
    const key = event.target.dataset.key;

    var state = this.state[key]

    if (value === true) {
      if (!state.includes(name)) {
        state.push(name)
      }
    }
    else if (value === false) {
      if (state.includes(name)) {
        const index = state.indexOf(name)
        state.splice(index, 1)
      }
    }

    this.setState({[key]: state});
  }

  render() {
    const { organisation_name, person_name, email_opt_out, loaded, unauthorized, errors, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/person-preferences/login"/>
    }

    if (error) {
      return <div>{error.message}</div>
    }

    if (loaded === false) {
      return (
        <Page header={PersonHeader} title="Email Preferences">
          <p>Loading ...</p>
        </Page>
      )
    }

    return (
      <Page header={PersonHeader} title={`Email Preferences for ${person_name} at ${organisation_name}`}>

        <form className="settings big-settings segment-settings" onSubmit={this.handleSubmit}>
          <div className="segment" id="email_preferences">
            { renderErrors(errors, 'email_opt_out') }

            <div className="row">
              <HelpText page={'person'} section={'email_opt_out'} />

              <input className="column small-bottom-margin" type="checkbox" name="user_mass_mail" id="user_mass_mail" data-key="email_opt_out" data-flipped="true" checked={!email_opt_out.includes("user_mass_mail")} onChange={this.handleMultiCheckbox} />
              <label className="column checkbox-label" htmlFor="user_mass_mail">Receive extra communications?</label>
            </div>
          </div>

          <div className="segment">
            <input type="submit" value="Save" disabled={this.state.updating} />
            { renderErrorWarning(errors) }
          </div>
        </form>
      </Page>
    )
  }

  componentDidMount() {
    request('GET', `/v1/p/person_preferences/0?marketing_token=${this.props.match.params.marketing_token}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          organisation_name: data.organisation_name,
          person_name: data.person_name,
          email_opt_out: data.email_opt_out,
          loaded: true
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ loaded: true, error: error })
        }
        else {
          this.setState({ loaded: true, errors: error })
        }
      })
  }
}

export default PersonPreferences;
